module.exports = __webpack_public_path__ + "img/antes_despues_255.8d5309ad.png";